import React from 'react'
import MetaSEO from './MetaSEO'
import CardAdjustments from './CardAdjustments'

const InspirationByUsPage = () => {
  return (
    <>
    <MetaSEO />
    <CardAdjustments />
    </>
  )
}

export default InspirationByUsPage